// extracted by mini-css-extract-plugin
export var lightMode = "_1b-0";